import { NotificationManager } from "react-notifications";
import { STATUS_MESSAGE } from "../declaration/StatusMessage";
import { instanceAxios } from "../app/axios";

export const getHandler = async (endpoint) => {
  try {
    const res = await instanceAxios.get(endpoint);
    if (res?.data?.status !== 0) {
      const message = res?.data?.message_error ?? res?.data?.msg; // message_error: 予期していないエラーから返すメッセージ　msg:エラーで返すメッセージ
      const msg = message || createAPIErrorMsg(res?.data?.status);
      return NotificationManager.error(msg, "失敗");
    }

    return res?.data;
  } catch (error) {
    if (!isErrorInvalidToken(error)) {
      const msg = error?.response?.data?.message_error ?? error?.response?.data?.msg; // message_error: 予期していないエラーから返すメッセージ　msg:エラーで返すメッセージ
      const message = msg || createAPIErrorMsg(error.response?.data?.status);
      NotificationManager.error(message, "失敗");
    }
    throw new Error(error);
  }
};

// add isShowMsg: condition show msg error
export const postHandler = async (endpoint, body, isShowMsg = true, isImport = false) => {
  try {
    const res = await instanceAxios.post(endpoint, body);
    if (isImport) return res;
    if (res?.data?.status !== 0) {
      // Create Error message
      const msg = res?.data?.message_error ?? res?.data?.msg; // message_error: 予期していないエラーから返すメッセージ　msg:エラーで返すメッセージ
      const message = msg || createAPIErrorMsg(res?.data?.status);
      return NotificationManager.error(message, "失敗");
    }
    return res?.data;
  } catch (error) {
    if (isShowMsg && !isErrorInvalidToken(error)) {
      const msg = error?.response?.data?.message_error ?? error?.response?.data?.msg; // message_error: 予期していないエラーから返すメッセージ　msg:エラーで返すメッセージ
      const message = msg || createAPIErrorMsg(error.response?.data?.status);
      NotificationManager.error(message, "失敗");
    }
    if (isImport) throw error;
    throw error;
  }
};

export const postFolderCreateHandler = async (endpoint, body, isShowMsg = true, isImport = false) => {
  try {
    const res = await instanceAxios.post(endpoint, body);
    if (isImport) return res;
    if (res?.data?.status !== 0) {
      // Create Error message
      const msg = res?.data?.message_error ?? res?.data?.msg; // message_error: 予期していないエラーから返すメッセージ　msg:エラーで返すメッセージ
      const message = msg || createAPIErrorMsg(res?.data?.status);
      return NotificationManager.error(message, "失敗");
    }
    return res?.data;
  } catch (error) {
    if (isShowMsg && !isErrorInvalidToken(error)) {
      // const msg = error?.response?.data?.message_error ?? error?.response?.data?.msg; 
      const msg = error?.response?.data?.msg?.info?.[0] ?? error?.response?.data?.message_error; // message_error: 予期していないエラーから返すメッセージ　msg:エラーで返すメッセージ
      const message = msg || createAPIErrorMsg(error.response?.data?.status);
      NotificationManager.error(message, "失敗");
    }
    if (isImport) throw error;
    throw new Error(error);
  }
};

export const formDataPostHandler = async (endpoint, body) => {
  try {
    const res = await instanceAxios.post(endpoint, body);
    if (res?.data?.status !== 0) {
      // Create Error message
      const msg = res?.data?.message_error ?? res?.data?.data?.msg; // message_error: 予期していないエラーから返すメッセージ　msg:エラーで返すメッセージ
      const message = msg || createAPIErrorMsg(res?.data?.status);
      return NotificationManager.error(message, "失敗");
    }
    return res?.data;
  } catch (error) {
    if (!isErrorInvalidToken(error)) {
      // const msg = error?.response?.data?.message_error ?? error?.response?.data?.msg[0];
      const msg = error?.response?.data?.msg[0] ?? error?.response?.data?.message_error;  // message_error: 予期していないエラーから返すメッセージ　msg:エラーで返すメッセージ
      const message = msg || createAPIErrorMsg(error?.response?.data?.status);
      NotificationManager.error(message, "失敗");
      throw new Error(error);
    }
  }
};

export const createAPIErrorMsg = (status) => {
  // return message base on status
  if (STATUS_MESSAGE[status]) {
    return STATUS_MESSAGE[status];
  }
  // Default message
  return "システムエラーが発生しました。管理者に問い合わせください。";
};


const isErrorInvalidToken = (error) => {
  const statusCode = error?.response?.status
  const messageError = error?.response?.data?.msg?.code

  if (statusCode === 401 && messageError === "token_not_valid") {
    return true
  }

  return false
}